import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { LoaderContent } from '../components/LoaderContent/LoaderContent';
import ProtectedPageSidebar from '../components/Sidebar/ProtectedPageSidebar';
import { useUserContext } from '../context/UserContext';
import VideoService from '../service/VideoService';
import { assignFontsForConfig, getUserPermission, getUserRole } from '../utils/videoUtils';
import queryString from 'query-string';
import { ScenesType } from '../../common/apis/CmsAPI';

export const withPermissionCheck = (Component, showSidebar = true, allowedRoles = []) => {
  return props => {
    const [isPermissionProcessing, setIsPermissionProcessing] = useState(true);
    const [videoDetails, setVideoDetails] = useState(null);
    const [unmountLoader, setUnmountLoader] = useState(false);
    const [permissions, setPermissions] = useState(null);
    const [storyRole, setStoryRole] = useState(null);
    const [videoConfig, setVideoConfig] = useState(null);
    const { user, isApprovalFlowEnabled, isReviewerUser, userCompanyId, userRole } = useUserContext();

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
      const checkVideoEditPermission = async () => {
        try {
          const query = queryString.parse(location.search);
          if (props.videoId == 'new' && !query.videoId) {
            setUnmountLoader(true);
            setPermissions({ allowedScenes: [], readStory: true, updateStory: true });
            return;
          }
          const video = await VideoService.getVideoDetails((props.videoId === 'new' ? query.videoId : props.videoId), ScenesType.REGULAR);
          setVideoDetails(video);
          VideoService.getStoryConfig(video.id).then(config => assignFontsForConfig(config)).then(preparedConfig => setVideoConfig(preparedConfig));
          // sceneAccess === 0 user has no rights to access editing page
          if (video.sceneAccess === 0) {
            console.log('User has no rights to access editing page');
            history.push('/eg/home');
          }
          const role = await getUserRole(video, user, userCompanyId, isApprovalFlowEnabled, isReviewerUser);
          const permissions = await getUserPermission(video.id, role);
          setPermissions(permissions);
          setStoryRole(role);
          // In case user is not an owner/participant, is from different company,
          // from same company but not a reviewer or folder admin/owner - redirect to dashboard
          !permissions.readStory && !permissions.allowedScenes.length && history.push('/eg/home');
          !permissions.readStory && !permissions.allowedScenes.length && console.log('User has no rights to access editing page');
        } catch (error) {
          console.log('Check failed with error', error);
          history.push('/eg/home');
        } finally {
          setUnmountLoader(true);
          setTimeout(() => {
            setIsPermissionProcessing(false);
          }, 150);
        }
      };
      if (user && userCompanyId) {
        if (location?.state?.dataFromStoryboard) {
          setVideoDetails({ ...location?.state?.storyDetails });
          setUnmountLoader(true);
          setTimeout(() => {
            setIsPermissionProcessing(false);
          }, 150);
        } else {
          if (allowedRoles?.length && !allowedRoles?.includes(userRole)) {
            console.log('User has no rights to access editing page');
            history.push('/eg/home');
          }
          checkVideoEditPermission();
        }
      }
    }, [props.videoId, user, userCompanyId]);

    if (isPermissionProcessing) {
      return (
        <>
          {showSidebar && <ProtectedPageSidebar />}
          <LoaderContent unmount={unmountLoader} centralized={!showSidebar} />
        </>
      );
    }

    return <Component {...props} initialVideoConfig={videoConfig} initialVideoDetails={videoDetails} userPermissions={permissions} storyRole={storyRole} />;
  };
};
